import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { MsaipPaymentBatchList } from '../../../models/msaip-payment-batch-list.model';
import { PaymentBatchExportToCsv } from '../../../models/payment-batch-list.model';
import { AppConstants } from '../../common/app-constants';
import { SettingsService } from '../../common/settings.service';
import { CommonSharedModule } from '../../common/shared.module';
import { ExportService } from '../../services/export.service';
import { MsaipPaymentScheduleService } from '../../services/msaip-payment-schedule.service';

@Component({
  selector: 'app-msaip-payment-schedule-milestone2',
  templateUrl: './msaip-payment-schedule-milestone2.component.html',
  styleUrls: ['./msaip-payment-schedule-milestone2.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class MsaipPaymentScheduleMilestone2Component implements OnInit {
  loading = false;
  isSpin = false;
  loadingIcon = 'fa-circle-o-notch';
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  @ViewChild('dt', { static: false }) dt!: Table;
  paymentBatchList: MsaipPaymentBatchList[] = [];
  pscols!: any[];
  totalRecords!: number;
  currentPageInfo!: string;
  tblPageNumber!: number;
  paymentBatchExport: PaymentBatchExportToCsv[] = [];
  datePipe = new DatePipe('en-US');

  constructor(
    private router: Router,
    private exportService: ExportService,
    private pmService: MsaipPaymentScheduleService,
    public settings: SettingsService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;

    this.pscols = [
      { field: 'paymentBatchName', header: 'Payment Batch Name' },
      {
        field: 'paymentBatchScheduleDate',
        header: 'Payment Batch Schedule Date'
      },
      { field: 'paymentBatchStatus', header: 'Payment Batch Status' },
      {
        field: 'actualPaymentCentralDate',
        header: 'Actual Payment Central Date'
      },
      { field: 'totalAmount', header: 'Total Amount' },
      { field: 'requestDetailIds', header: 'Engagement Ids' },
      { field: 'noOfIncentives', header: 'No of Incentives' },
      { field: 'partnersPaid', header: 'Partners Paid' }
    ];

    this.getMsaipMilestone2PaymentBatch();
  }
  exportToCSV() {
    this.paymentBatchExport = [];
    this.paymentBatchList.forEach(data => {
      this.paymentBatchExport.push({
        PaymentBatchName: data.paymentBatchName,
        PaymentBatchScheduleDate:
          this.datePipe.transform(
            data.paymentBatchScheduleDate,
            'MM/dd/yyyy'
          ) || '',
        AnticipatedPaymentDate:
          this.datePipe.transform(data.anticipatedPaymentDate, 'MM/dd/yyyy') ||
          '',
        ActualPaymentCentralDate:
          this.datePipe.transform(
            data.actualPaymentCentralDate,
            'MM/dd/yyyy'
          ) || '',
        TotalAmount: data.totalAmount,
        NoofIncentives: data.noOfIncentives,
        PartnersPaid: data.partnersPaid
      });
    });

    this.exportService.exportToCsv(
      this.paymentBatchExport,
      'PaymentSchedule.csv'
    );
  }
  createNewPaymentBatch() {
    this.router.navigate(['/new-msaip-payment-batch-milestone2']);
  }
  editPaymentBatchDetails(event, paymentBatchName: string) {
    this.router.navigate([
      '/msaip-milestone2-edit-payment-batch',
      paymentBatchName
    ]);
  }
  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }
  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.dt) {
      this.dt.sortField = 'paymentBatchName';
      this.dt.sortOrder = -1;
      this.dt.reset();
    }

    if (this.paymentBatchList === null || this.paymentBatchList.length === 0) {
      this.totalRecords = 0;
      this.currentPageInfo = 'No Records Found';
    } else {
      this.getMsaipMilestone2PaymentBatch();
      this.totalRecords = this.paymentBatchList.length;
      if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }

      if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    }
  }
  getMsaipMilestone2PaymentBatch() {
    this.pmService.getMsaipMilestone2PaymentBatch().subscribe(pbList => {
      if (pbList === null || pbList.length === null || pbList.length === 0) {
        this.loading = false;
      } else {
        this.paymentBatchList = pbList;
        this.totalRecords = this.paymentBatchList.length;

        if (this.totalRecords === 0) {
          this.currentPageInfo = 'No Record Found';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords > this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords <= this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.totalRecords +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        this.loading = false;
      }
    });
  }
}
